// extracted by mini-css-extract-plugin
module.exports = {"heading":"PlayFreeMoreInfoLink_heading__76ieu"};